import React from 'react';
import '@atlaskit/css-reset';
import styled from '@emotion/styled';
 
import "react-responsive-modal/styles.css";
import "./css/modal.css";
import { getBoardIdFromURL} from "./../util/common";
import { Modal } from "react-responsive-modal";
import AIGenerator from "../services/AIGenerator.js";
import checkMark from './checkMark.png';
import aiSmallIcon from "./ai-icon.png";
import { announce } from "./../util/liveRegion.js";


const emailSenderServiceURL = "https://us-central1-idea-boards.cloudfunctions.net/generateBoardSummaryAndSendEmailToUser";

const OpenModaLButton = styled.button`
  cursor: pointer;
  color: white;
  border: none;
  border-radius: 5px;
  background: linear-gradient(135deg, #8141cb 0%, #ee8663 100%);
  font-weight: 500;
  font-size: 14px;
  position: relative;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  height: 35px;
  padding: 0 14px;

  &:focus {
    outline: 2px solid #0052CC;
    outline-offset: 2px;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.4),
      transparent
    );
    animation: shine 5s linear infinite;
  }

  @keyframes shine {
    0% {
      left: -100%;
    }
    20% {
      left: 100%;
    }
    100% {
      left: 100%;
    }
  }
`;

const ButtonIcon = styled.img`
  width: 18px;
  height: 22px;
`;

const Hero = styled.div`
  margin: -20px -20px 20px;
  padding: 28px 32px;
  background: linear-gradient(135deg, #8141cb 0%, #ee8663 100%);
  color: white;
  border-radius: 7px 7px 0 0;
  display: flex;
  align-items: center;
  gap: 18px;
`;

const HeroIconWrap = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const HeroIcon = styled.img`
  width: 30px;
  height: 36px;
`;

const HeroTitle = styled.h2`
  margin: 0 0 4px 0;
  font-size: 22px;
  font-weight: 600;
  color: white;
`;

const HeroSubtitle = styled.p`
  margin: 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.92);
  line-height: 1.4;
`;

const BenefitList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 24px 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Benefit = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 14px;
  color: #3a3a3a;
  line-height: 1.5;
`;

const BenefitCheck = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #e8f5e9;
  color: #2e7d32;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 700;
  margin-top: 1px;
`;

const FormLabel = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #4a5056;
  margin-bottom: 6px;
`;

const EmailRow = styled.div`
  display: flex;
  gap: 10px;
  align-items: stretch;
`;

const EmailInput = styled.input`
  height: 42px;
  border-radius: 6px;
  font-size: 14px;
  border: 1px solid #cdd2d6;
  padding: 0 12px;
  flex: 1;
  font-family: inherit;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #0052CC;
    box-shadow: 0 0 0 3px rgba(0, 82, 204, 0.15);
  }
`;

const SubmitButton = styled.button`
  height: 42px;
  padding: 0 22px;
  color: white;
  border: none;
  border-radius: 6px;
  background: linear-gradient(135deg, #8141cb 0%, #ee8663 100%);
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.2s ease, transform 0.05s ease;

  &:hover { opacity: 0.92; }
  &:active { transform: translateY(1px); }

  &:focus {
    outline: 2px solid #0052CC;
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const PrivacyNote = styled.p`
  margin: 12px 0 0 0;
  font-size: 12px;
  color: #7a8088;
  line-height: 1.4;
`;

const ConfirmationContent = styled.div`
  text-align: center;
  padding: 16px 24px 8px;
`;

const ConfirmationIconWrap = styled.div`
  width: 76px;
  height: 76px;
  border-radius: 50%;
  background: #e8f5e9;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
  box-shadow: 0 0 0 8px rgba(46, 125, 50, 0.08);
`;

const ConfirmationTitle = styled.h2`
  margin: 0 0 10px 0;
  font-size: 24px;
  font-weight: 600;
  color: #1f2328;
`;

const ConfirmationText = styled.p`
  margin: 0 auto;
  max-width: 360px;
  color: #5a6068;
  font-size: 15px;
  line-height: 1.5;
`;

const ConfirmationEmail = styled.span`
  color: #1f2328;
  font-weight: 600;
`;

const GotItButton = styled.button`
  margin-top: 24px;
  height: 42px;
  padding: 0 28px;
  color: white;
  border: none;
  border-radius: 6px;
  background: linear-gradient(135deg, #8141cb 0%, #ee8663 100%);
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.05s ease;

  &:hover { opacity: 0.92; }
  &:active { transform: translateY(1px); }

  &:focus {
    outline: 2px solid #0052CC;
    outline-offset: 2px;
  }
`;

const isValidEmail = (value) =>
  typeof value === 'string' &&
  value.length > 0 &&
  value.length < 50 &&
  value.includes('@') &&
  value.includes('.');

export default class GPTModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        open: false,
        email: "",
        confirmationModalOpen: false
      };
  }

  handleSubmit = async () => {
    const {email: userEmail} = this.state;
    if (
        userEmail &&
        typeof userEmail === "string" &&
        userEmail?.length > 0 && 
        userEmail?.length < 50 && 
        userEmail?.includes("@") &&
        userEmail?.includes(".")
      ) { 
        try {
            const document = await AIGenerator.createASummaryRequest(this.state.email);
            const IDOfStoredFirebaseDocment = document?.id;
            if(IDOfStoredFirebaseDocment && IDOfStoredFirebaseDocment.length > 0) {
                // if there is a document ID, then we can send the email
                // console.log("sending request ", `${emailSenderServiceURL}/?userEmail=${userEmail}&summaryRequestDocumentId=${IDOfStoredFirebaseDocment}&documentId=${getBoardIdFromURL()}`)

                fetch(`${emailSenderServiceURL}/?userEmail=${userEmail}&summaryRequestDocumentId=${IDOfStoredFirebaseDocment}&documentId=${getBoardIdFromURL()}`);           
            }
            this.setState({ open: false });
            this.setState({confirmationModalOpen: true});
            announce("Request submitted. You will receive a summary by email shortly.");
        } catch (error) {
            console.log(error)
        }

       
      }  
  };

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  render() {
    const { open, confirmationModalOpen, email } = this.state;
    const canSubmit = isValidEmail(email);
    return (
      <>
        <OpenModaLButton type="button" onClick={this.onOpenModal} aria-haspopup="dialog">
          <ButtonIcon src={aiSmallIcon} alt="" aria-hidden="true" />
          Send AI Summary to Your Inbox
        </OpenModaLButton>
        <Modal
          open={open}
          onClose={this.onCloseModal}
          center
          classNames={{
            overlay: 'customOverlay',
            modal: 'customModal',
          }}
          styles={{
            modal: {
              width: '90%',
              minWidth: '320px',
              maxWidth: '560px',
              margin: '0 auto'
            }
          }}
          aria={{ labelledby: 'ai-summary-title' }}
        >
          <Hero>
            <HeroIconWrap>
              <HeroIcon src={aiSmallIcon} alt="" aria-hidden="true" />
            </HeroIconWrap>
            <div>
              <HeroTitle id="ai-summary-title">Get an AI Summary</HeroTitle>
              <HeroSubtitle>We'll email you a clear recap of this board's ideas — perfect for sharing or revisiting later.</HeroSubtitle>
            </div>
          </Hero>

          <BenefitList>
            <Benefit>
              <BenefitCheck aria-hidden="true">✓</BenefitCheck>
              Capture key takeaways to share with stakeholders and stay aligned.
            </Benefit>
            <Benefit>
              <BenefitCheck aria-hidden="true">✓</BenefitCheck>
              Keep a record of your session to track progress and follow up with ease.
            </Benefit>
            <Benefit>
              <BenefitCheck aria-hidden="true">✓</BenefitCheck>
              Free. No spam. No sharing. Ever.
            </Benefit>
          </BenefitList>

          <FormLabel htmlFor="user-email">Your email</FormLabel>
          <EmailRow>
            <EmailInput
              type="email"
              id="user-email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => this.setState({ email: e.target.value })}
            />
            <SubmitButton type="button" onClick={this.handleSubmit} disabled={!canSubmit}>
              Send me a summary
            </SubmitButton>
          </EmailRow>
          <PrivacyNote>We only use your email to send this summary.</PrivacyNote>
        </Modal>

        <Modal
          open={confirmationModalOpen}
          onClose={() => this.setState({ confirmationModalOpen: false })}
          center
          classNames={{
            overlay: 'customOverlay',
            modal: 'customModal',
          }}
          styles={{
            modal: {
              width: '90%',
              minWidth: '320px',
              maxWidth: '440px',
              margin: '0 auto'
            }
          }}
          aria={{ labelledby: 'ai-summary-confirm-title' }}
        >
          <ConfirmationContent>
            <ConfirmationIconWrap>
              <img src={checkMark} width="36" alt="" aria-hidden="true" />
            </ConfirmationIconWrap>
            <ConfirmationTitle id="ai-summary-confirm-title">You're all set!</ConfirmationTitle>
            <ConfirmationText>
              Your board summary is on its way to{' '}
              <ConfirmationEmail>{email}</ConfirmationEmail>. It should land in your inbox in a few minutes.
            </ConfirmationText>
            <GotItButton type="button" onClick={() => this.setState({ confirmationModalOpen: false })}>
              Got it
            </GotItButton>
          </ConfirmationContent>
        </Modal>
      </>
    );
  }
}
